"use strict";

var __importDefault = function (e) {
  return e && e.__esModule ? e : {
    default: e
  };
},
    react_1 = (Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports.SlideInfo = void 0, __importDefault(require("react"))),
    types_1 = require("../types"),
    utils_1 = require("../utils");

exports.SlideInfo = function (e) {
  var t = e.activeIndex,
      s = e.itemsCount,
      e = e.renderSlideInfo,
      t = utils_1.getSlideInfo(t, s).item;
  if ("function" == typeof e) return react_1.default.createElement("div", {
    className: types_1.Classnames.SLIDE_INFO
  }, e({
    item: t,
    itemsCount: s
  }));
  e = utils_1.concatClassnames(types_1.Classnames.SLIDE_INFO_ITEM, types_1.Modifiers.SEPARATOR);
  return react_1.default.createElement("div", {
    className: types_1.Classnames.SLIDE_INFO
  }, react_1.default.createElement("span", {
    className: types_1.Classnames.SLIDE_INFO_ITEM
  }, t), react_1.default.createElement("span", {
    className: e
  }, "/"), react_1.default.createElement("span", {
    className: types_1.Classnames.SLIDE_INFO_ITEM
  }, s));
};